/**
 * StreamRift mode (2026-10-20) — the trader's opt-in to the new Penelope layout: a settings map that jumps to any knob
 * group, one action row in the same place on every Penelope screen, and a table-first desk. Every setting and button
 * of today's layout is still there; with the mode off every Penelope screen renders exactly as before.
 *
 * The pref lives on the account (`users.prefs.streamriftMode`, `src/lib/traderPrefs.ts`), so it follows the trader
 * to every browser; it reaches this module through `authStore` like MrGreenMode does. Display only: nothing on the
 * order path reads it. Each Penelope surface reads it once and passes it down as a prop, so the components stay pure.
 */
import { useAuthStore } from './authStore';

/** True when the signed-in trader has StreamRift mode on. */
export function streamriftModeEnabled(): boolean {
  return useAuthStore.getState().user?.prefs?.streamriftMode === true;
}

/** React: is StreamRift mode on for this trader? */
export function useStreamriftMode(): boolean {
  return useAuthStore((s) => s.user?.prefs?.streamriftMode === true);
}
